var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "section-listGame GamesBlockWithBigRightItem",
      class: _vm.additionalRowClasses
    },
    [
      _c("div", { staticClass: "section-listGame__content" }, [
        _c(
          "div",
          { staticClass: "listGame__list lastBox" },
          _vm._l(_vm.loadedGames, function(item, index) {
            return _c("game-item", {
              key: index,
              staticClass: "listGame__list-item",
              attrs: {
                item: item,
                "image-property-name": _vm.gameImagePropertyName(index)
              }
            })
          }),
          1
        )
      ]),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showLoadMoreButton,
              expression: "showLoadMoreButton"
            }
          ],
          staticClass: "section-listGame__footer"
        },
        [
          _c(
            "v-btn",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.hasMoreGames,
                  expression: "hasMoreGames"
                }
              ],
              staticClass: "btn-load",
              attrs: { loading: _vm.loading },
              on: { click: _vm.showMoreGames }
            },
            [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$t("front.game.button.load_more")) +
                  "\n        "
              )
            ]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }